<template>
	<section class="wib-reviews">
		<h3 class="wib-reviews__heading">
			{{ reviewsHeading | stripTags }}
		</h3>
		<div class="container">
			<div class="row">
				<div
					class="col-md-6"
					v-for="review in bldReviews"
					:key="review.id"
				>
					<div class="wib-review">
						<div class="wib-review__reviewer-photo">
							<img :src="review.logo_url" :alt="review.title">
						</div>
						<blockquote class="wib-review__quote">
							<h5 class="wib-review__reviewer-name">
								{{ review.title | stripTags }}:
							</h5>
							<div class="wib-review__text" v-html="review.body" />
						</blockquote>
					</div>
				</div>
			</div>
			<div class="wib-reviews__stars">
				<star-rating
					:title="`Rating average: ${reviewScore.averageRating}`"
					:rating="reviewScore.averageRating"
					active-color="#FAA50B"
					inactive-color="#5F707F"
					:star-size="17"
					:show-rating="false"
					:increment="0.5"
					:border-width="1"
					border-color="transparent"
					:rounded-corners="false"
					:read-only="true"
					:star-points="[23, 2, 14, 17, 0, 19, 10, 34, 7, 50, 23, 43, 38, 50, 36, 34, 46, 19, 31, 17]"
				/>
				<router-link to="/reviews" class="wib-reviews__stars__link">
					{{ reviewScore.count }} Reviews
				</router-link>
			</div>
			<a href="/reviews" target="_blank" class="wib-reviews__button btn">
				SEE CUSTOMER REVIEWS
			</a>
		</div>
	</section>
</template>

<script>
export default {
	name: "BldReviews",
	props: {
		reviewsData: {
			type: Array,
			required: true
		},
		reviewScore: {
			type: Object,
			required: true
		}
	},
	computed: {
		reviewsHeading() {
			return this.reviewsData.length ? this.reviewsData[0].title : "";
		},
		bldReviews() {
			return this.reviewsData.length ? this.reviewsData.slice(1) : [];
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@s/_asset-mixers.scss';

.wib-reviews {
    padding: 75px 0;
    background: linear-gradient(180deg, #230036, #190027 100%);
    color: $white;

    @media (max-width: 991px) {
        padding: 45px 15px 35px;
    }

    &__heading {
        font-size: 36px;
        line-height: 43px;
        text-align: center;
        margin-top: 0;
        margin-bottom: 55px;

        @media (max-width: 991px) {
            margin-bottom: 25px;
        }

        @media (max-width: 580px) {
            text-align: left;
        }
    }

    .wib-review {
        display: flex;
        justify-content: center;

        @media (max-width: 991px) {
            margin-bottom: 15px;
        }

        &__reviewer-photo {
            img {
                width: 95px;

                @media (max-width: 991px) {
                    width: 65px;
                }
            }
        }

        &__reviewer-name {
            font-weight: bold;
            margin: 0;
        }

        &__quote {
            border-left: none;
            margin: 0;
            padding: 0;
            padding-left: 15px;
            color: #fff;
            font-size: 14px;
            line-height: 21px;
        }

        &__text {
            max-width: 335px;
        }
    }

    &__stars {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 60px;

        @media (max-width: 991px) {
            margin-top: 10px;
        }

        &__link {
            font-size: 16px;
            margin-top: 5px;
            margin-left: 5px;
        }
    }

    &__button {
        margin: 15px auto 0;
        background-color: $oldpurple;
        color: $white;
        max-width: 330px;
        display: flex;
        justify-content: center;
        font-size: 20px;
        padding: 12px 0;
        transition: all .2s;

        &:hover {
            color: $oldpurple;
            background: $white;
        }

        @media (max-width: 991px) {
            max-width: 550px;
        }

        @media (min-width: 580px) and (max-width: 991px) {
            margin: 30px auto 0;
        }

        @media (max-width: 580px) {
            margin: 15px -15px 0;
        }
    }

    .col-md-6 {
        @media (max-width: 991px) {
            padding: 0;
        }
    }
}
</style>